var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"gridContainer",staticStyle:{"align-content":"center","align-items":"center","justify-content":"center","width":"100%","height":"100%","display":"flex","flex-wrap":"wrap"}},_vm._l((_vm.children),function(child,index){return _c('div',{key:index,style:({
      width: _vm.itemWidth + 'px',
      height: _vm.itemHeight + 'px',
      margin: _vm.margin + 'px',
      position: 'relative',
    })},[_vm._t("child",null,{"child":child})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }